// Deleted Product hidden on collection
document.addEventListener("DOMContentLoaded", function () {
  // Only run if the current path is exactly /product/12
  if (window.location.href === "https://fabricsandhome.com/collections/marcus-william-fabrics") {

//    console.log("true")  
    function hideParentProductContainer(root = document) {
      const anchors = root.querySelectorAll('a.pdp-anchor[href*="fabricsandhome.com/products/marcus-william-fabrics-runyon-runy-1"]');
      anchors.forEach(anchor => {
        const parent = anchor.closest('.product-container');
        if (parent) {
          parent.style.display = 'none';
        }
      });
    }

    // Run on page load
    hideParentProductContainer();

    // Watch for dynamically added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (
              node.matches &&
              node.matches('a.pdp-anchor[href*="fabricsandhome.com/products/marcus-william-fabrics-runyon-runy-1"]')
            ) {
              const parent = node.closest('.product-container');
              if (parent) {
                parent.style.display = 'none';
              }
            }
            hideParentProductContainer(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }else{
//   console.log("false")
  }
});